module.exports = __webpack_public_path__ + "img/svg/loading.5623e99939b1055f54d9cd692957edcb.svg";